module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    staticClass: "mdl-dialog",
    attrs: {
      "id": "dialog"
    }
  }, [_c('h3', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v(_vm._s(_vm.dialog.title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [(_vm.dialog.isHTML) ? _c('div', {
    staticClass: "html",
    domProps: {
      "innerHTML": _vm._s(_vm.dialog.content)
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.dialog.content))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.accept()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cerrar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15039f9c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Dialog/index.vue
// module id = 226
// module chunks = 0